export interface SmsCreditTopupRequestModel {
  optionId: number;
}
